export default __webpack_public_path__ + "static/media/100004.203d653e.jpg";